import { getColumns } from './LookupBuilder.Grid';
import BespokeConditionBuilder from '../../Functions/Bespoke/BespokeConditionBuilder';
import ConditionBuilder from '../../Functions/Condition/ConditionBuilder';
import conditionDisplayHelper from '../../../infrastructure/helpers/functions/condition/conditionDisplayHelper';
import conditionHelper from '../../../infrastructure/helpers/functions/condition/conditionHelper';
import enpointLookupAdapter from '../../../infrastructure/helpers/functions/lookup/enpointLookupAdapter';
import ErrorList from '../../Common/ErrorList/ErrorList';
import locationType from '../../../types/functions/Location/LocationType';
import Lookup from '../../../types/functions/Lookup';
import React from 'react';
import reportConfigNavigation from '../../../infrastructure/helpers/report/navigation/reportConfigNavigation';
import ReportLogicLocation from '../../../types/functions/Location/ReportLogicLocation';
import reportLogicReferenceHelper from '../../../infrastructure/helpers/functions/report/reportLogicReferenceHelper';
import StatementBuilderProps from '../../Functions/Statement/StatementBuilderProps';
import typeHelper from '../../../infrastructure/helpers/common/typeHelper';
import reorderHelper from '../../../infrastructure/helpers/common/reorderHelper';
import Operand from '../../../types/functions/Operand/Operand';
import {
    findReferencedComponentsInLookups, lookupTypeOtions, prepareLookups, prepareOptionsFromGlobalLookups, prepareOptionsFromLookups, prepareWarningMessageOnGlobalLookupAdd,
    updateLookupToLookupReferences
} from './LookupBuilder.Helpers';
import Condition from '../../../types/functions/Condition/Condition';
import IdNameAndNumber from '../../../types/report/IdNameAndNumber';
import reportComponentBuildersHelper from '../Common/ReportComponentsHelper';
import ReportConfigComponentLock from '../../../types/report/ReportConfigComponentLock';
import DragAndDropError from '../../../types/report/DragAndDropError';
import ComponentType from '../../../types/report/ComponentType';
import ActionType from '../../../types/report/ActionType';
import { reportType } from '../../../infrastructure/constants/reportType';
import { onReferenceSelected, reportConfigPrefix } from '../../../infrastructure/helpers/report/reference/helper';
import DragAndDropItem from '../../../types/report/DragAndDropItem';
import assignmentHelper from '../../../infrastructure/helpers/functions/assignment/assignmentHelper';
import appRoutes from '../../../infrastructure/constants/appRoutes';
import Mode from '../../../types/report/Mode';
import copyArray from '../../../infrastructure/helpers/common/copyArray';
import RefDataSource from '../../../types/report/RefDataSource';
import IngestionConfig from '../../../types/ingestion/IngestionConfig';
import copyObject from '../../../infrastructure/helpers/common/copyObject';
import sortingHelper from '../../../infrastructure/helpers/common/sortingHelper';
import operandHelper from '../../../infrastructure/helpers/functions/operand/operandHelper';
import UserDefinedFunction from '../../../types/report/UserDefinedFunction';
import { prepareFunctions, updateReportComponentToFunctionCondition } from '../UserDefinedFunctions/UserDefinedFunctionSelector/UserDefinedFunction.Helpers';
import { prepareRefDataSourcesForConfig } from '../Pages/ReportPage/ReportPage.Helpers';
import './styles.scss';
import IdAndType from '../../../types/report/IdAndType';
import { htmlIds } from '../../../infrastructure/helpers/report/navigation/reportConfigNavigation.HtmlIds';
import { buildText, onGlobalComponentLinkClick, prepareComponentType } from '../Common/ReferenceComponentHelper/ReferenceComponentHelper';
import NameAndNumber from '../../../types/report/NameAndNumber';
import WarningModal from '../../Common/Modals/WarningModal/WarningModal';
import ReportComponentStatus from '../Common/ReportComponentStatus/ReportComponentStatus';
import AddComponentWithGlobalOptionsPopup from '../GlobalModule/AddComponentWithGlobalOptionsPopup';
import actions from '../../../store/actions';
import store from '../../../store/store';
import { Unsubscribe } from 'redux';
import reportLogicLocationHelper from '../../../infrastructure/helpers/functions/report/reportLogicLocationHelper';
import SearchByType from '../../../types/report/SearchByType';
import SearchByFor from '../../Common/AutocompleteInput/SearchByFor';
import Component from '../../../types/common/Component';
import httpClient from '../../../infrastructure/helpers/common/httpClient';
import CustomDropdownOption from '../../Common/Dropdown/CustomDropdownOption';
import ReportConfigNavigationPayload from '../../../types/report/ReportConfigNavigationPayload';
import ReportLogicList from '../Common/ReportLogicList/ReportLogicList';
import domNavigationHelper from '../../../infrastructure/helpers/html/domNavigationHelper';
import ReportLogicListWithPaging from '../Common/ReportLogicList/ReportLogicListWithPaging';

class LookupBuilder extends React.Component<StatementBuilderProps<Lookup>, {
    showPopup: boolean,
    showGlobalLookupReferencesPopup: boolean,
    globalLookuWarningMessage: string,
    missingDataSources: Map<number, string>,
    missingLookups: Lookup[],
    missingFunctions: UserDefinedFunction[],
    globalLookupName: string,
    showWarningPopupOnPaste: boolean,
    pasteLookupLogicLocation: ReportLogicLocation,
    pasteLookupLogicMessage: string,
    globalLookupModuleId: number,
    navigateTo: string,
    items: Lookup[],
    searchBy: string,
    refresh: boolean
}> {
    private unsubscribeComponentChange: Unsubscribe | undefined;
    private unsubscribeNavigateTo: Unsubscribe | undefined;
    private unsubscribeNavigatedTo: Unsubscribe | undefined;
    private unsubscribeReferenceSelected: Unsubscribe | undefined;

    constructor(props: StatementBuilderProps<Lookup>) {
        super(props);

        this.state = {
            showPopup: false,
            showGlobalLookupReferencesPopup: false,
            globalLookuWarningMessage: '',
            missingDataSources: new Map<number, string>(),
            missingLookups: [],
            missingFunctions: [],
            globalLookupName: '',
            showWarningPopupOnPaste: false,
            pasteLookupLogicLocation: {} as ReportLogicLocation,
            pasteLookupLogicMessage: '',
            globalLookupModuleId: 0,
            navigateTo: '',
            items: [],
            searchBy: '',
            refresh: false
        }

        this.onDataSource1Change = this.onDataSource1Change.bind(this);
        this.onDataSource2Change = this.onDataSource2Change.bind(this);
        this.onNameChange = this.onNameChange.bind(this);
        this.onLookupTypeChange = this.onLookupTypeChange.bind(this);
        this.onBespokeToggleClick = this.onBespokeToggleClick.bind(this);
        this.getConditionContent = this.getConditionContent.bind(this);
        this.getLookupReferences = this.getLookupReferences.bind(this);
        this.reorder = this.reorder.bind(this);
        this.onAddLookupClick = this.onAddLookupClick.bind(this);
        this.onLookupConfiguredInPopup = this.onLookupConfiguredInPopup.bind(this);
        this.onRemoveLookupClick = this.onRemoveLookupClick.bind(this);
        this.tryLock = this.tryLock.bind(this);
        this.onGlobalLookupLinkClick = this.onGlobalLookupLinkClick.bind(this);
        this.addMissingComponents = this.addMissingComponents.bind(this);
        this.prepareOptionsForGlobalLookups = this.prepareOptionsForGlobalLookups.bind(this);
        this.onPasteLogicClick = this.onPasteLogicClick.bind(this);
        this.onCopyClick = this.onCopyClick.bind(this);
        this.onPasteLookupLogicConfirmed = this.onPasteLookupLogicConfirmed.bind(this);
        this.onDropBetweenLookups = this.onDropBetweenLookups.bind(this);
        this.onReferenceSelected = this.onReferenceSelected.bind(this);
        this.onGlobalLookupModeClick = this.onGlobalLookupModeClick.bind(this);
        this.onLookupReferenceSelected = this.onLookupReferenceSelected.bind(this);
        this.onReferenceNavigatedTo = this.onReferenceNavigatedTo.bind(this);
        this.onSearchBySelected = this.onSearchBySelected.bind(this);
        this.onMainNavigationStepClick = this.onMainNavigationStepClick.bind(this);
        this.onReferenceSelected = this.onReferenceSelected.bind(this);
        this.onGlobalLookupModeClick = this.onGlobalLookupModeClick.bind(this);
        this.onSearchBySelected = this.onSearchBySelected.bind(this);
        this.onComponentChange = this.onComponentChange.bind(this);
    }

    componentDidMount() {
        this.setInternalIds();
        this.setLookupReadonly();
        this.unsubscribeComponentChange = store.subscribe(this.onComponentChange);
        this.unsubscribeReferenceSelected = store.subscribe(this.onLookupReferenceSelected);
        this.unsubscribeNavigatedTo = store.subscribe(this.onReferenceNavigatedTo);
        this.unsubscribeNavigateTo = store.subscribe(this.onMainNavigationStepClick);

        this.setState({ items: copyArray(this.props.reportConfig.lookups) });
    }

    onReferenceNavigatedTo() {
        let appState = store.getState();

        if (appState.action !== actions.reference.navigated) {
            return;
        }

        this.setState({ navigateTo: '' });
    }

    onMainNavigationStepClick() {
        let appState = store.getState();

        if (appState.action !== actions.navigation.mainNavigation) {
            return;
        }

        if (appState.mainNavigation.location.statement === locationType.statement.lookup) {

            store.dispatch({
                type: actions.navigation.expand, payload: {
                    expandHtmlId: htmlIds.lookups
                } as ReportConfigNavigationPayload
            });

            if (this.props.reportConfig.type === reportType.accuracy) {
                let items = copyArray(this.props.reportConfig.lookups);

                this.setState({ navigateTo: htmlIds.lookups, items, refresh: true });
            }
            else {
                domNavigationHelper.navigate(appState.mainNavigation.details.definitionHtmlId as string);
            }
        }
    }

    onLookupReferenceSelected() {
        let appState = store.getState();

        if (appState.action !== actions.reference.selected) {
            return;
        }

        let stateProperties = appState.navigateToReportConfigSection;

        if (stateProperties.expandHtmlId.split('-').includes(htmlIds.lookups)) {

            store.dispatch({ type: actions.navigation.expand, payload: stateProperties });

            if (this.props.reportConfig.type === reportType.accuracy) {
                let number = parseInt(stateProperties.scrollToHtmlId.split('-')[1]);

                let items = copyArray(this.props.reportConfig.lookups).filter(x => x.number === number);

                this.setState({ navigateTo: stateProperties.scrollToHtmlId, items, refresh: true });
            }
            else {
                store.dispatch({ type: actions.navigation.expand, payload: stateProperties });

                domNavigationHelper.navigate(stateProperties.scrollToHtmlId);
            }
        }
    }

    onComponentChange() {
        let appState = store.getState();

        if (appState.action !== actions.component.change) {
            return;
        }

        if (appState.componentChange?.location?.statement === locationType.statement.lookup) {

            let items = copyArray(this.props.reportConfig.lookups);

            if (appState.componentChange?.actionType === ActionType.Add) {

                let number = appState.componentChange.location.statementNumber;

                let htmlId = reportConfigNavigation.buildLookupId(number);

                this.setState({ navigateTo: htmlId, items, refresh: true });
            }
            else if (appState.componentChange?.actionType === ActionType.Remove) {
                this.setState({ navigateTo: '', items, refresh: true });
            }
            else {
                let lookups = [] as Lookup[];

                this.state.items.forEach((v) => {
                    let lookupInProps = this.props.reportConfig.lookups.find(x => x.number === v.number);

                    if (lookupInProps) {
                        lookups.push(copyObject(lookupInProps));
                    }
                });

                this.setState({ items: lookups, refresh: false, navigateTo: '' });
            }
        }
    }

    componentWillUnmount() {
        (this.unsubscribeComponentChange as Unsubscribe)();
        (this.unsubscribeNavigateTo as Unsubscribe)();
        (this.unsubscribeNavigatedTo as Unsubscribe)();
        (this.unsubscribeReferenceSelected as Unsubscribe)();
    }

    setInternalIds() {
        let index = 1;
        this.props.reportConfig.lookups.forEach((lookup) => {
            lookup._internalId = index;
            index += 1;
        })
    }

    setLookupReadonly() {
        this.props.reportConfig.lookups.forEach((lookup: Lookup) => {
            lookup.isReadOnly = lookup.mode === Mode.Global;
        })
    }

    async reorder(dragNumber: number, dropNumber: number): Promise<void> {
        let dragIndex = this.props.reportConfig.lookups.findIndex(x => x.number === dragNumber);
        let dropIndex = this.props.reportConfig.lookups.findIndex(x => x.number === dropNumber);
        let draggedLookup = this.props.reportConfig.lookups.find(v => v.number === dragNumber) as Lookup;
        let dropLookup = this.props.reportConfig.lookups.find(v => v.number === dropNumber) as Lookup;


        const isLockedDragged = await this.tryLock(undefined, draggedLookup);
        let isLockedDropped = false;
        if (!isLockedDragged) {
            isLockedDropped = await this.tryLock(undefined, dropLookup);
        }

        if (!isLockedDragged && !isLockedDropped) {
            this.clearAllErrors();

            let isValidDrag = this.isValidDragAndDropLookup(draggedLookup, dropLookup);

            if (isValidDrag) {

                reorderHelper.reorderWithNumbersChange(this.props.reportConfig.lookups, dragIndex, dropIndex);

                reorderHelper.changeReferences(this.props.reportConfig,
                    this.props.reportConfig.lookups, (operand: Operand) => {
                        if (operand.lookupNumber && operand.lookupNumber === draggedLookup.number) {
                            operand.lookupNumber = dropLookup.number;
                        }
                        else if (operand.lookupNumber && operand.lookupNumber === dropLookup.number) {
                            operand.lookupNumber = draggedLookup.number;
                        }
                    }
                );

                let loc = reportLogicLocationHelper.createLocation(draggedLookup.number, locationType.statement.lookup);

                this.props.onDragAndDrop(this.props.reportConfig.lookups, loc);
            }
        }
    }

    isValidDragAndDropLookup(draggedLookup: Lookup, dropLookup: Lookup) {

        let result: DragAndDropError = reportComponentBuildersHelper.validateDragAndDrop(draggedLookup as DragAndDropItem, dropLookup as DragAndDropItem, ComponentType.Lookup);

        if (result.error) {
            const lookupReferenced = this.props.statements.find(s => s.number === result.number) || {} as Lookup;

            result.error = `${result.error} The referenced lookup is "${lookupReferenced.name}".`;

            const number = result.isDrag ? draggedLookup.number : dropLookup.number;

            const statement = this.props.statements.find(s => s.number === number) || {} as Lookup;

            statement.errors = [result.error];

            this.props.onStatementChange(statement);

            return false;
        }

        return true;
    }

    createLookupIdAndNumber(): Map<number, number> {

        const lookupsIdAndNumber = new Map<number, number>();
        this.props.reportConfig.lookups.forEach((lookup) => {
            const id = lookup._internalId;
            lookupsIdAndNumber.set(id, lookup.number);
        });

        return lookupsIdAndNumber;
    }

    onDataSource1Change(value: string, lookupNumber: number): void {
        let changes = { number: lookupNumber } as Lookup;
        let error = this.props.validateRemoveStatement(lookupNumber);
        if (error) {
            changes.errors = [error];
        }
        else {
            changes.dataSource1Id = enpointLookupAdapter.getDataSourceId(value);
            changes.dataSource2Id = null;
            changes.condition = conditionHelper.getEmpty();
            changes.isEndpoint = enpointLookupAdapter.isEndpoint(value)
            changes.isBespoke = false;
            changes.bespokeCondition = '';
        }
        this.props.onStatementChange(changes);
    }

    onDataSource2Change(dataSourceId: string, lookupNumber: number): void {
        let changes = { number: lookupNumber } as Lookup;
        let error = this.props.validateRemoveStatement(lookupNumber);
        if (error) {
            changes.errors = [error];
        }
        else {
            changes.errors = [];

            changes.dataSource2Id = parseInt(dataSourceId);
            let currentLookup = this.props.reportConfig.lookups.find(l => l.number === lookupNumber);
            let condition = Object.assign({}, currentLookup?.condition);
            condition.operand2 = {} as Operand;
            changes.condition = condition;
        }
        this.props.onStatementChange(changes);
    }

    onLookupConfiguredInPopup(name: string, type: string, isInsertAfter: boolean, selectedLookupNumber: string, globalLookupModuleId: number | undefined): void {

        this.setState({ showPopup: false });

        const insertionAfterLookupNumber: number = parseInt(selectedLookupNumber);

        this.props.onAddStatementClick(name, (lookup, lookups) => {
            lookups = reorderHelper.rearangeElementsWhenAddNewOne(lookups, lookup, isInsertAfter, insertionAfterLookupNumber) as Lookup[];

            let number = lookups.map(v => v.number).sort((x, y) => { return x > y ? 1 : x < y ? -1 : 0; }).pop() || 0;

            lookup.errors = [];
            lookup.isMultiResult = type === 'true';

            if (globalLookupModuleId) {
                let globalLookup = this.props.collections.globalModuleConfig.lookups.find(l => l.id === globalLookupModuleId) as Lookup;

                lookup.globalLookupModuleId = globalLookupModuleId;

                lookup.mode = Mode.Global;
                lookup.isReadOnly = true;
                lookup.name = name ? name : globalLookup?.name || '';

                this.proceedWithGlobalLookupReferences(lookup, globalLookup);
            }
            else {
                lookup.mode = Mode.Local;
                lookup._internalId = lookup.number;

                if (name) {
                    lookup.name = name
                }
                else {
                    lookup.name = `lookup-${number}`;
                }

                reorderHelper.changeReferences(this.props.reportConfig,
                    lookups, (operand: Operand, oldAndNewNumbers: Map<number, number>, componentType: ComponentType | undefined) => {
                        if (componentType !== ComponentType.AccuracyValidation) {
                            if (operand.lookupNumber && oldAndNewNumbers.has(operand.lookupNumber)) {
                                operand.lookupNumber = oldAndNewNumbers.get(operand.lookupNumber) as number;
                            }
                        }
                    }
                );
            }
        });
    }

    proceedWithGlobalLookupReferences(lookup: Lookup, globalLookup: Lookup) {

        let lookupDataSourceIds: number[] = [globalLookup.dataSource1Id || 0, globalLookup.dataSource2Id || 0];
        let dataSourcesIds = new Set<number>(lookupDataSourceIds);

        let referencedLookups: Lookup[] = [];

        let referencedFunctions: UserDefinedFunction[] = [];

        let missingDataSourcesMap = new Map<number, string>();

        findReferencedComponentsInLookups(this.props.collections.globalModuleConfig,
            this.props.reportConfig,
            lookup.globalLookupModuleId as number,
            dataSourcesIds,
            referencedLookups,
            referencedFunctions,
            missingDataSourcesMap);

        let reportConfigFunctionsIds = this.props.reportConfig.userDefinedFunctions.filter(x => x.mode === Mode.Global && x.globalUDFModuleId).map(x => x.id);

        let missingFunctions = referencedFunctions.filter(x => x.id && !reportConfigFunctionsIds.includes(x.id as number));

        let reportConfigLookupsIds: number[] = this.props.reportConfig.lookups.filter(x => x.mode === Mode.Global && x.globalLookupModuleId).map(x => x.id as number);

        let missingLookups = referencedLookups.filter(x => x.id && !reportConfigLookupsIds.includes(x.id as number));

        if (missingDataSourcesMap.size > 0 || referencedLookups.length > 0) {

            let message = prepareWarningMessageOnGlobalLookupAdd(Array.from(missingDataSourcesMap.values()), referencedLookups);

            message += `
                    Click "Ok" if you want them to be added automatically for you.

                    Click "Cancel" to add them manually.`;

            this.setState({
                showGlobalLookupReferencesPopup: true,
                globalLookuWarningMessage: message,
                missingDataSources: missingDataSourcesMap,
                missingLookups,
                missingFunctions,
                showPopup: false,
                globalLookupName: lookup.name,
                globalLookupModuleId: lookup.globalLookupModuleId as number
            });
        }
        else {


            lookup.dataSource1Id = globalLookup.dataSource1Id;
            lookup.dataSource2Id = globalLookup.dataSource2Id;

            lookup.condition = copyObject(globalLookup?.condition as Condition);

            updateLookupToLookupReferences(lookup, this.props.collections.globalModuleConfig, this.props.reportConfig);
            updateReportComponentToFunctionCondition(lookup.condition, this.props.collections.globalModuleConfig.userDefinedFunctions);

            this.setState({ showPopup: false, globalLookupName: '' });
        }
    }

    clearAllErrors(): void {
        this.props.reportConfig.lookups.forEach((lookup) => {
            lookup.errors = [];
        });
    }

    async onRemoveLookupClick(number: number, setup?: (x: Lookup[]) => void, event?: React.MouseEvent<HTMLElement>): Promise<void> {

        const isLocked = await this.tryLock(number);

        if (!isLocked) {

            let componentId = undefined;

            if (this.props.reportConfig.type === reportType.globalModule) {
                componentId = this.props.reportConfig.lookups.find(x => x.number === number)?.id || undefined;
            }

            let validationError = await reportComponentBuildersHelper.validateAction(
                number,
                false,
                this.props.reportConfig.lookups as IdNameAndNumber[],
                ComponentType.Lookup,
                ActionType.Remove,
                this.props.reportConfig,
                componentId);

            let loc = { statement: locationType.statement.lookup, statementNumber: number } as ReportLogicLocation

            if (!validationError) {
                this.props.onRemoveStatementClick(number, (lookups: Lookup[]) => {
                    lookups = reorderHelper.rearangeElementsWhenRemoveOne(lookups) as Lookup[];

                    reorderHelper.changeReferences(this.props.reportConfig,
                        lookups, (operand: Operand, oldAndNewNumbers: Map<number, number>, componentType: ComponentType | undefined) => {
                            if (componentType !== ComponentType.AccuracyValidation) {
                                if (operand.lookupNumber && oldAndNewNumbers.has(operand.lookupNumber)) {
                                    operand.lookupNumber = oldAndNewNumbers.get(operand.lookupNumber) as number;
                                }
                            }
                        }
                    );
                }, undefined, undefined, loc);
            }
            else {
                this.props.onRemoveStatementClick(number, undefined, undefined, validationError);
            }
        }
    }

    async onNameChange(name: string, number: number): Promise<void> {
        const isLocked = await this.tryLock(number);
        if (!isLocked) {
            this.props.onStatementChange({ name: name, number: number } as Lookup);
        }
    }

    onLookupTypeChange(isMultiResult: boolean, number: number): void {
        let changes = { number: number } as Lookup;
        let error = this.props.validateRemoveStatement(number);
        if (error) {
            changes.errors = [error];
        }
        else {
            changes.isMultiResult = isMultiResult;
        }
        this.props.onStatementChange(changes);
    }

    async onBespokeToggleClick(isBespoke: boolean, lookup: Lookup, event?: React.MouseEvent<HTMLElement>): Promise<void> {

        const isLocked = await this.tryLock(undefined, lookup);
        if (!isLocked) {
            let changes = { number: lookup.number, isBespoke: isBespoke } as Lookup;
            if (!typeHelper.isNumber(lookup.dataSource2Id)) {
                changes.dataSource2Id = (this.props.collections.dataSources.find(x => x.id !== lookup.dataSource1Id) as IngestionConfig).id;
            }
            if (isBespoke) {
                changes.bespokeCondition = conditionDisplayHelper.buildConditions(lookup.condition, this.props.reportConfig.lookups, this.props.reportConfig.dictionaries, [], this.props.collections.dataSources,
                    this.props.collections.reportFields, this.props.collections.customDataSourceFields, this.props.reportConfig.type);
            }
            this.props.onStatementChange(changes);
        }
    }

    async getLookupReferences(number: number): Promise<CustomDropdownOption[]> {

        let config = copyObject(this.props.reportConfig);

        config.lookups = config.lookups.filter(x => x.number !== number);

        let references = reportLogicReferenceHelper.getLookupReferences(number, config, this.props.collections);

        let options: CustomDropdownOption[] = references.map((x) => { return { asUrl: false, component: { htmlId: x.value, name: x.text, componentType: x.componentType, componentNumber: x.number, reportConfigId: x.configId, componentInnerType: x.innerType, mainComponentNumber: x.mainComponentNumber } as Component } });

        if (this.props.reportConfig.type === reportType.globalModule) {

            let lookup = this.props.reportConfig.lookups.find(x => x.number === number);

            if (lookup?.id) {

                let component = { componentInnerType: ComponentType.Lookup, componentType: ComponentType.Lookup, componentId: lookup?.id, reportConfigId: config.id, componentNumber: lookup?.number } as Component;

                let res = await httpClient.post('report/global-module/references', component);

                let refs = res.data as Component[];

                refs.forEach((ref) => {
                    ref.name = buildText(ref.reportConfigName || '', ref.name || '', ref.componentType);
                    options.push({
                        component: ref,
                        asUrl: true
                    } as CustomDropdownOption);
                });
            }
        }

        return options;
    }

    onAddLookupClick(): void {
        this.setState({ showPopup: true });
    }

    async tryLock(number?: number, lookup?: Lookup): Promise<boolean> {

        if (this.props.reportConfig.type === reportType.accuracy && this.props.onComponentContainerClick) {

            let currentLookup = lookup || this.props.reportConfig.lookups.find(v => v.number === number);
            if (!currentLookup?.isUsedByCurrentUser) {
                return await this.props.onComponentContainerClick({ componentId: currentLookup?.id || 0, componentType: ComponentType.Lookup, number: currentLookup?.number || 0 });
            }
        }
        return false;
    }

    async onReorderConditions(condition: Condition, lookup: Lookup) {

        const isLocked = await this.tryLock(lookup.number);
        if (!isLocked) {
            lookup.condition = condition;
            this.props.onStatementChange(lookup);
        }
    }

    async onClearClick(condition: Condition, lookup: Lookup): Promise<void> {

        await this.tryLock(undefined, lookup);

        let newLookup = assignmentHelper.clearOperandsInStatementByConditionNumber(condition.number, lookup) as Lookup;

        this.props.onStatementChange(newLookup);
    }

    onGlobalLookupLinkClick(lookupNumber: number) {

        let route = `${appRoutes.reporting.edit}?id=${this.props.collections.globalModuleConfig.id}&htmlid=${reportConfigNavigation.buildLookupId(lookupNumber)}&section=${htmlIds.lookups}` || '';

        window.open(route)?.focus();
    }

    addMissingComponents() {

        let refDataSources = prepareRefDataSourcesForConfig(this.props.collections.globalModuleDataSources, this.props.collections.dataSources, this.state.missingDataSources, this.props.reportConfig);

        let mainLookup = copyObject(this.props.reportConfig.lookups.find(x => x.name === this.state.globalLookupName) as Lookup);

        let globalLookup = copyObject(this.props.collections.globalModuleConfig.lookups.find(x => x.id === mainLookup.globalLookupModuleId) as Lookup);

        mainLookup.dataSource1Id = globalLookup.dataSource1Id;
        mainLookup.dataSource2Id = globalLookup.dataSource2Id;

        mainLookup.condition = copyObject(globalLookup?.condition as Condition);

        let missingLookups = copyArray(this.state.missingLookups);

        let lookupsOldAndNewNumbers = new Map<number, number>();

        let lookups = prepareLookups(missingLookups, this.props.reportConfig, mainLookup, lookupsOldAndNewNumbers);

        let oldAndNewFunctionsNumbers = new Map<number, number>();

        let missingFunctions = copyArray(this.state.missingFunctions);

        let functions: UserDefinedFunction[] = [];

        if (missingFunctions.length) {

            functions = prepareFunctions(missingFunctions, this.props.reportConfig.userDefinedFunctions, oldAndNewFunctionsNumbers);

            let lookupsForUpdate = lookups.filter(l => missingLookups.map(l => l.id).includes(l.globalLookupModuleId || 0)).concat(mainLookup);

            lookupsForUpdate.forEach(l => updateReportComponentToFunctionCondition(l.condition, this.props.collections.globalModuleConfig.userDefinedFunctions));
        }
        else {
            functions = copyArray(this.props.reportConfig.userDefinedFunctions);

            let lookupsForUpdate = lookups.filter(x => missingLookups.map(x => x.id).includes(x.globalLookupModuleId || 0)).concat(mainLookup);

            lookupsForUpdate.forEach((l) => {
                updateLookupToLookupReferences(l, this.props.collections.globalModuleConfig, this.props.reportConfig);
                updateReportComponentToFunctionCondition(l.condition, functions);
            });
        }

        sortingHelper.sortByNumberAsc(lookups as IdNameAndNumber[]);

        this.props.onAddGlobalReferencedLookups && this.props.onAddGlobalReferencedLookups(lookups, refDataSources);

        this.setState({ showGlobalLookupReferencesPopup: false });
    }

    prepareOptionsForGlobalLookups() {

        let configDataSources = this.props.reportConfig.refDataSources
            .concat([{ id: this.props.reportConfig.rawDataSourceId, runStatus: 0, dataSouceKind: 'Raw' }] as RefDataSource[]);

        return prepareOptionsFromGlobalLookups(this.props.collections.globalModuleConfig?.lookups, configDataSources, this.props.reportConfig.lookups)
    }

    onPasteLogicClick(location: ReportLogicLocation) {
        let sourceLogicLookup = this.props.reportConfig.lookups.find(x => x.number === this.props.clipboard?.statementNumber as number) as Lookup;

        let targetLookup = copyObject(this.props.reportConfig.lookups.find(x => x.number === location.statementNumber as number)) as Lookup;

        let targetLookupReferences = reportLogicReferenceHelper.getLookupReferences(targetLookup.number, this.props.reportConfig, this.props.collections);

        if (sourceLogicLookup?.dataSource1Id === targetLookup?.dataSource1Id &&
            sourceLogicLookup?.dataSource2Id === targetLookup?.dataSource2Id) {

            this.props.onPasteClick(location);
        }
        else if (targetLookupReferences.length) {
            let firstReference = targetLookupReferences[0];

            targetLookup.errors = [`This Lookup is referenced "${firstReference.text}". Remove references first.`];

            this.props.onStatementChange(targetLookup);
        }
        else {
            const message = 'Copying lookup logic will change datasources.\n Are you sure to proceed.\n Click OK to continue';
            this.setState({ showWarningPopupOnPaste: true, pasteLookupLogicLocation: location, pasteLookupLogicMessage: message });
        }
    }

    onCopyClick(location: ReportLogicLocation, lookup: Lookup) {
        location.statementNumber = lookup.number;

        this.props.onCopyClick(location);
    }

    onPasteLookupLogicConfirmed() {

        let sourceLogicLookup = this.props.reportConfig.lookups.find(x => x.number === this.props.clipboard?.statementNumber as number) as Lookup;

        let targetLookup = copyObject(this.props.reportConfig.lookups.find(x => x.number === this.state.pasteLookupLogicLocation.statementNumber as number)) as Lookup;

        let condition = copyObject(sourceLogicLookup?.condition) as Condition;

        targetLookup.errors = [];
        targetLookup.condition = condition;
        targetLookup.dataSource1Id = sourceLogicLookup?.dataSource1Id as number;
        targetLookup.dataSource2Id = sourceLogicLookup?.dataSource2Id as number;

        this.props.onStatementChange(targetLookup);
    }

    onDropBetweenLookups(dragNumber: number, dropNumber: number) {

        let draggedLookup = this.props.reportConfig.lookups.find(v => v.number === dragNumber) as Lookup;
        let dropLookup = this.props.reportConfig.lookups.find(v => v.number === dropNumber) as Lookup;

        let isValidDrag = this.isValidDragAndDropLookup(draggedLookup, dropLookup);

        if (isValidDrag) {
            let numbersMap = reorderHelper.prepareNewNumbersMapOnDragBetween(dragNumber, dropNumber);

            operandHelper.traverseReportConfigSectionsForOperands(this.props.reportConfig, (operand: Operand, itemName?: string, componentType?: ComponentType | undefined) => {
                if (componentType !== ComponentType.AccuracyValidation) {
                    if (operand.lookupNumber && numbersMap.has(operand.lookupNumber)) {
                        operand.lookupNumber = numbersMap.get(operand.lookupNumber) as number;
                    }
                }
            });

            this.props.onDragStatementBetween && this.props.onDragStatementBetween(numbersMap);
        }
    }

    getConditionContent(lookup: Lookup): JSX.Element {

        let useGlobalData = lookup.mode === Mode.Global;

        if (lookup.isBespoke) {
            return (
                <>
                    <BespokeConditionBuilder
                        keyword={this.props.details.keyword}
                        statement={lookup}
                        onChange={this.props.onStatementChange}
                        isReadOnly={this.props.isReadOnly}
                    />
                </>
            );
        }
        const reportConfigComponentLock: ReportConfigComponentLock = { componentId: lookup.id || 0, componentType: ComponentType.Lookup, number: lookup.number };

        return (
            <>
                <ConditionBuilder
                    reportConfigType={this.props.reportConfig.type}
                    isReadOnly={lookup.isReadOnly || this.props.isReadOnly}
                    allowCopy={true}
                    keyword='IF'
                    functions={this.props.reportConfig.userDefinedFunctions}
                    globalFunctions={this.props.collections.globalModuleConfig.userDefinedFunctions}
                    lookups={this.props.reportConfig.lookups}
                    dictionaries={this.props.reportConfig.dictionaries}
                    variables={[]}
                    dataSources={useGlobalData ? this.props.collections.dataSources.concat(this.props.collections.globalModuleDataSources) : this.props.collections.dataSources}
                    reportFields={this.props.collections.reportFields}
                    customDataSourceFields={this.props.collections.customDataSourceFields}
                    location={{ statement: locationType.statement.lookup, statementNumber: lookup.number } as ReportLogicLocation}
                    condition={lookup.condition}
                    onLogicalOperatorChange={(location, operator, event) => this.props.onLogicalOperatorChange(location, operator, event, reportConfigComponentLock)}
                    onParenthesesChange={(location, count, type, event) => this.props.onParenthesesChange(location, count, type, event, reportConfigComponentLock)}
                    onAddConditionClick={(location, operator, event) => this.props.onAddConditionClick(location, operator, event, reportConfigComponentLock)}
                    onRemoveConditionClick={(location, event) => this.props.onRemoveConditionClick(location, event, reportConfigComponentLock)}
                    onComparisonTypeChange={(location, value, event) => this.props.onComparisonTypeChange(location, value, event, reportConfigComponentLock)}
                    onOperandClick={(location, event) => this.props.onOperandClick(location, event, reportConfigComponentLock)}
                    onCopyClick={(location) => this.onCopyClick(location, lookup)}
                    onPasteClick={this.onPasteLogicClick}
                    onClearClick={async (e, condition) => { this.onClearClick(condition, lookup); }}
                    allowPaste={() => true}
                    onReorderConditions={(condition) => { this.onReorderConditions(condition, lookup); }} />

                <ErrorList errors={lookup.errors} className="mt-2" />

                <ReportComponentStatus
                    reportType={this.props.reportConfig.type}
                    lastUpdatedTime={lookup.lastUpdatedTime}
                    isReadOnly={this.props.isReadOnly} />
            </>
        );
    }

    onReferenceSelected(option: CustomDropdownOption) {

        if (option.component.name?.startsWith(reportConfigPrefix) && this.props.reportConfig.type === reportType.globalModule) {
            let type = prepareComponentType(option.component.componentType);

            onGlobalComponentLinkClick(option.component.componentNumber, type, option.component.reportConfigId || 0, option.component.componentInnerType, option.component.mainComponentNumber);
        }
        else {
            onReferenceSelected(option.component.htmlId || '');
        }
    }

    onGlobalLookupModeClick(globalLookupId: number) {

        let lookupNumber = this.props.collections.globalModuleConfig.lookups.find(x => x.id === globalLookupId)?.number as number;

        this.onGlobalLookupLinkClick(lookupNumber);
    }

    onSearchInPaging(options: NameAndNumber[]) {

        store.dispatch({
            type: actions.navigation.expand, payload: {
                expandHtmlId: htmlIds.variables
            } as ReportConfigNavigationPayload
        });

        if (this.props.reportConfig.type === reportType.accuracy) {
            let items = options?.[0]?.number ? copyArray([this.props.reportConfig.lookups.find(x => x.number === options?.[0]?.number)]) as Lookup[] : [];

            this.setState({ items, refresh: true });
        }
        else {
            domNavigationHelper.navigate(reportConfigNavigation.buildLookupId(options?.[0].number || 0));
        }
    }

    onSearchBySelected(value: string) {

        if (value === SearchByType.Id) {
            this.setState({ searchBy: value });
        }

        if (value === SearchByType.Name) {
            this.setState({ searchBy: value });
        }
    }

    render(): JSX.Element {
        return (
            <div>
                {!this.props.isReadOnly &&
                    <SearchByFor
                        onSearchByChange={this.onSearchBySelected}
                        getOptions={() => this.props.reportConfig.lookups.map((x) => { return { name: this.state.searchBy === SearchByType.Id ? x.number.toString() : x.name, number: x.number } }) as NameAndNumber[]}
                        searchByOptions={['Id', 'Name']}
                        onClearClick={() => this.setState({ items: this.props.reportConfig.lookups })}
                        onSearch={(options: NameAndNumber[]) => this.onSearchInPaging(options)}
                    />
                }
                {this.props.reportConfig.type === reportType.accuracy ?
                    <ReportLogicListWithPaging
                        navigateTo={this.state.navigateTo}
                        isPagingUpdate={this.state.refresh}
                        onDropZoneDrop={this.onDropBetweenLookups}
                        isWaiting={this.props.isWaiting}
                        items={this.state.items}
                        columns={getColumns(
                            this.tryLock,
                            this.onDataSource1Change,
                            this.onDataSource2Change,
                            this.onNameChange,
                            this.onLookupTypeChange,
                            this.onBespokeToggleClick,
                            this.onRemoveLookupClick,
                            this.getLookupReferences,
                            this.reorder,
                            this.props.collections,
                            this.props.reportConfig.type,
                            this.props.isReadOnly,
                            this.onReferenceSelected,
                            this.onGlobalLookupModeClick,
                            this.props.reportConfig.id as number)}
                        getContent={(item) => {
                            return this.getConditionContent(item);
                        }}
                        getKey={l => l.number}
                        createHtmlId={l => reportConfigNavigation.buildLookupId(l.number)}
                        onClick={(e: React.MouseEvent<HTMLElement>, item: Lookup) => {
                            if (item.isLocked && item.isReadOnly) {
                                this.tryLock(item.number);
                            }
                        }} />
                    :
                    <ReportLogicList
                        onDropZoneDrop={this.onDropBetweenLookups}
                        isWaiting={this.props.isWaiting}
                        items={this.props.reportConfig.lookups}
                        columns={getColumns(
                            this.tryLock,
                            this.onDataSource1Change,
                            this.onDataSource2Change,
                            this.onNameChange,
                            this.onLookupTypeChange,
                            this.onBespokeToggleClick,
                            this.onRemoveLookupClick,
                            this.getLookupReferences,
                            this.reorder,
                            this.props.collections,
                            this.props.reportConfig.type,
                            this.props.isReadOnly,
                            this.onReferenceSelected,
                            this.onGlobalLookupLinkClick,
                            this.props.reportConfig.id as number)}
                        getContent={(item) => {
                            return this.getConditionContent(item);
                        }}
                        getKey={l => l.number}
                        createHtmlId={l => reportConfigNavigation.buildLookupId(l.number)}
                        onClick={(e: React.MouseEvent<HTMLElement>, item: Lookup) => {
                            if (item.isLocked && item.isReadOnly) {
                                this.tryLock(item.number);
                            }
                        }} />
                }
                {
                    !this.props.isReadOnly &&
                    !this.props.isWaiting &&
                    <div className="mt-4 mb-4">
                        <button onClick={this.onAddLookupClick} className="btn btn-light">+ Lookup</button>
                    </div>
                }
                {this.state.showPopup &&
                    <AddComponentWithGlobalOptionsPopup
                        reportConfig={this.props.reportConfig}
                        onConfiguredInPopup={this.onLookupConfiguredInPopup}
                        getGlobalOptions={() => this.prepareOptionsForGlobalLookups()}
                        dropdownOptions={prepareOptionsFromLookups(this.props.reportConfig.lookups, this.props.collections.dataSourceOptions)}
                        onClose={() => this.setState({ showPopup: false })}
                        title='New Lookup'
                        dropdownTypeName='Lookup Type'
                        componentType={ComponentType.Lookup}
                        components={this.props.reportConfig.lookups as IdNameAndNumber[]}
                        dataTypeOtions={lookupTypeOtions}
                        globalCollection={(this.props.collections.globalModuleConfig.lookups.map((x) => { return { id: x.id, type: x.isMultiResult ? 'Multi Result' : 'Regular' } as IdAndType }) as IdAndType[])}
                    />
                }
                {this.state.showGlobalLookupReferencesPopup &&
                    <WarningModal
                        message={this.state.globalLookuWarningMessage}
                        onOkClick={() => { this.addMissingComponents(); }}
                        title='Global lookup references'
                        onCancelClick={() => this.setState({ showGlobalLookupReferencesPopup: false })}
                    />
                }
                {this.state.showWarningPopupOnPaste &&
                    <WarningModal
                        message={this.state.pasteLookupLogicMessage}
                        onOkClick={this.onPasteLookupLogicConfirmed}
                        title='Copy lookup logic'
                        onCancelClick={() => this.setState({ showWarningPopupOnPaste: false })}
                    />
                }
            </div>
        );
    }
}
export default LookupBuilder;
